import api from './api';

const masterService = {
  // Sales Channel related
  getSalesChannels: () => api.get('/admin/saleschannel'),
  
  // Content Type related
  getContentTypes: () => api.get('/admin/contenttype'),
  
  // Video Show related
  getVideoShows: () => api.get('/admin/videoshow'),
  
  // TV Show related
  getTvShows: () => api.get('/admin/tvshow'),
  
  // Languages related
  getLanguages: () => api.get('/admin/language'),
  
  // Image upload
  uploadImage: (formData) => api.post('/admin/upload/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  
  // Image remove
  removeImage: (payload) => api.delete('/admin/upload/image', { data: payload }),
  
  // OnBoarding related
  getAllOnBoarding: (payload) => api.get('/admin/onboarding', { params: payload }),
  
  getSingleOnBoarding: (mobId) => api.get(`/admin/onboarding/${mobId}`),
  
  saveOnBoarding: (payload) => api.post('/admin/onboarding', payload),
  
  saveOnBoardingOrderAndPlan: (payload) => api.post('/admin/onboarding-order', payload),
  
  // Subscription Plans
  getSubscriptionPlans: () => api.get('/admin/subscription-plan'),
  
  // Tags related
  getTags: () => api.get('/admin/tag'),
  
  // Seasons related
  getAllSeasonsOfTvShow: (payload) => api.get('/admin/season', { params: payload }),
  
  // Country related
  getCountries: (payload) => {
    const { perPage, currentPage, searchText, status } = payload;
    let url = `/admin/country?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    if (status && status !== 'all') url += `&status=${status}`;
    return api.get(url);
  },
  
  getSingleCountry: (countryId) => api.get(`/admin/country/${countryId}`),
  
  addCountry: (payload) => api.post('/admin/country/', payload),
  
  editCountry: (countryId, payload) => api.put(`/admin/country/${countryId}`, payload),
  
  // Currency related
  getCurrencies: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/currency?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSingleCurrency: (currId) => api.get(`/admin/currency/${currId}`),
  
  addCurrency: (payload) => api.post('/admin/currency', payload),
  
  updateCurrency: (currId, payload) => api.put(`/admin/currency/${currId}`, payload),
  
  // Video Genre related
  getGenres: (payload) => {
    const { perPage, currentPage, searchText, status } = payload;
    let url = `/admin/video_genre?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    if (status && status !== 'all') url += `&status=${status}`;
    return api.get(url);
  },
  
  getSingleGenre: (genreId) => api.get(`/admin/video_genre/${genreId}`),
  
  addGenre: (payload) => api.post('/admin/video_genre', payload),
  
  updateGenre: (genreId, payload) => api.put(`/admin/video_genre/${genreId}`, payload),
  
  // Video Language related
  getVideoLanguages: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/languages/all?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSingleLanguage: (langId) => api.get(`/admin/language/${langId}`),
  
  addLanguage: (payload) => api.post('/admin/language', payload),
  
  updateLanguage: (langId, payload) => api.put(`/admin/language/${langId}`, payload),
  
  // Tag related
  getTagList: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/tag?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSingleTag: (tagId) => api.get(`/admin/tag/${tagId}`),
  
  addTag: (payload) => api.post('/admin/tag', payload),
  
  updateTag: (tagId, payload) => api.put(`/admin/tag/${tagId}`, payload),
  
  // Content Type related
  getContentTypes: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/content_type?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSingleContentType: (ctId) => api.get(`/admin/content_type/${ctId}`),
  
  addContentType: (payload) => api.post('/admin/content_type', payload),
  
  updateContentType: (ctId, payload) => api.put(`/admin/content_type/${ctId}`, payload),
  
  // Sales Channel related (already exists but need to update for pagination)
  getSalesChannels: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/sales_channel?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSingleSalesChannel: (scId) => api.get(`/admin/sales_channel/${scId}`),
  
  addSalesChannel: (payload) => api.post('/admin/sales_channel', payload),
  
  updateSalesChannel: (scId, payload) => api.put(`/admin/sales_channel/${scId}`, payload),
  
  // FAQ related
  getFaqs: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/faq?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSingleFaq: (faqId) => api.get(`/admin/faq/${faqId}`),
  
  addFaq: (payload) => api.post('/admin/faq', payload),
  
  updateFaq: (faqId, payload) => api.put(`/admin/faq/${faqId}`, payload),
  
  // Privacy Policy related
  getPrivacyPolicies: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/privacy-policy?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSinglePrivacyPolicy: (ppId) => api.get(`/admin/privacy-policy/${ppId}`),
  
  addPrivacyPolicy: (payload) => api.post('/admin/privacy-policy', payload),
  
  updatePrivacyPolicy: (ppId, payload) => api.put(`/admin/privacy-policy/${ppId}`, payload),
  
  // Terms & Conditions related
  getTermsConditions: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/terms-conditions?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSingleTermsConditions: (tcId) => api.get(`/admin/terms-conditions/${tcId}`),
  
  addTermsConditions: (payload) => api.post('/admin/terms-conditions', payload),
  
  updateTermsConditions: (tcId, payload) => api.put(`/admin/terms-conditions/${tcId}`, payload),
  
  // About Us related
  getAboutUs: () => api.get('/admin/about-us'),
  
  updateAboutUs: (payload) => api.put('/admin/about-us', payload),
  
  // Mobile App Store related
  getMobileAppStores: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/mobile-app-store?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSingleMobileAppStore: (storeId) => api.get(`/admin/mobile-app-store/${storeId}`),
  
  addMobileAppStore: (payload) => api.post('/admin/mobile-app-store', payload),
  
  updateMobileAppStore: (storeId, payload) => api.put(`/admin/mobile-app-store/${storeId}`, payload),
  
  // Content Complaints related
  getContentComplaints: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/content-complaints?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSingleContentComplaint: (contentId) => api.get(`/admin/content-complaints/${contentId}`),
  
  addContentComplaint: (payload) => api.post('/admin/content-complaints', payload),
  
  updateContentComplaint: (contentId, payload) => api.put(`/admin/content-complaints/${contentId}`, payload),
  
  // Payment Modes related
  getPaymentModes: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/payment_mode?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSinglePaymentMode: (pmId) => api.get(`/admin/payment_mode/${pmId}`),
  
  addPaymentMode: (payload) => api.post('/admin/payment_mode/', payload),
  
  updatePaymentMode: (pmId, payload) => api.put(`/admin/payment_mode/${pmId}`, payload),
  
  // Payment Keys related
  getPaymentKeys: (payload) => {
    const { perPage, currentPage, searchText } = payload;
    let url = `/admin/payment_key?perPage=${perPage}&currentPage=${currentPage}`;
    if (searchText) url += `&search=${searchText}`;
    return api.get(url);
  },
  
  getSinglePaymentKey: (paymentKeysId) => api.get(`/admin/payment_key/${paymentKeysId}`),
  
  addPaymentKey: (payload) => api.post('/admin/payment_key/', payload),
  
  updatePaymentKey: (paymentKeysId, payload) => api.put(`/admin/payment_key/${paymentKeysId}`, payload)
};

export default masterService;
